// One observer per margin and one document listener, regardless of section count.
const groups = new Map()

const publish = target => {
  const active = target.intersecting && !document.hidden
  if (active !== target.active) {
    target.active = active
    target.callback(active)
  }
}

const syncDocument = () => {
  groups.forEach(group => group.targets.forEach(publish))
}

export const observeActivity = (element, callback, rootMargin = '0px') => {
  let group = groups.get(rootMargin)
  if (!group) {
    const targets = new Map()
    const observer = window.IntersectionObserver
      ? new window.IntersectionObserver(entries => {
          entries.forEach(entry => {
            const target = targets.get(entry.target)
            if (!target) return
            target.intersecting = entry.isIntersecting
            publish(target)
          })
        }, { rootMargin })
      : null
    group = { targets, observer }
    if (!groups.size) document.addEventListener('visibilitychange', syncDocument)
    groups.set(rootMargin, group)
  }

  const target = { callback, intersecting: !group.observer, active: undefined }
  group.targets.set(element, target)
  publish(target)
  if (group.observer) group.observer.observe(element)

  return () => {
    if (group.observer) group.observer.unobserve(element)
    group.targets.delete(element)
    if (!group.targets.size) {
      if (group.observer) group.observer.disconnect()
      groups.delete(rootMargin)
    }
    if (!groups.size) document.removeEventListener('visibilitychange', syncDocument)
  }
}

// Keep the same SVG paths, durations and phase; only suspend invisible work.
export const observeSvgActivity = element => observeActivity(element, active => {
  element.querySelectorAll('path').forEach(path => {
    path.style.animationPlayState = active ? '' : 'paused'
  })
  if (element.pauseAnimations && element.unpauseAnimations) {
    if (active) element.unpauseAnimations()
    else element.pauseAnimations()
  }
})
